import React from 'react';
import { CheckAccountStatusBeforeDeposit } from 'modules/2024-q3/grasshopper-sunset/deposit/check-account-status-before-deposit/check-account-status-before-deposit';

export const DepositTransition = () => {
  return <CheckAccountStatusBeforeDeposit />;
};
